import i18n from 'i18next'
import commonSv from './locales/sv.json'
import commonEn from './locales/en.json'

// Chronicle is consumed by the clubhouse SPA host, which owns the i18next
// .init() against the shared module-level singleton. Chronicle previously
// called .init() at module load here too, which reset the singleton's
// resource bundles — clobbering every namespace clubhouse registered before
// chronicle's module was first evaluated. We also previously registered the
// common bundle as a load-time side effect, which made *importing anything
// from chronicle* trigger i18n state; tests that didn't init i18next then
// crashed. Registration is now explicit and idempotent.
//
// deepMerge=true: merge nested keys into the existing 'common' bundle.
// overwrite=false: clubhouse's keys win on collision (chronicle is a guest).
let commonRegistered = false
export function registerCommonI18n(): void {
  if (commonRegistered) return
  commonRegistered = true
  i18n.addResourceBundle('sv', 'common', commonSv, true, false)
  i18n.addResourceBundle('en', 'common', commonEn, true, false)
}

export { i18n }
